import { BarChart3, Compass, LineChart, ListChecks, MessagesSquare, UserRound, History } from 'lucide-react';

// As abas do painel são nossas; o `tab` de cada pilar no JSON (who, niche,
// community, sales, plan) só diz em qual delas ele aparece.
export const TABS = [
    { name: 'overview', label: 'Resumo', icon: BarChart3 },
    { name: 'who', label: 'Perfil', icon: UserRound },
    { name: 'niche', label: 'Mercado', icon: Compass },
    { name: 'community', label: 'Público', icon: MessagesSquare },
    { name: 'sales', label: 'Vendas', icon: LineChart },
    { name: 'plan', label: 'Próximos passos', icon: ListChecks },
    { name: 'history', label: 'Histórico', icon: History },
];

export const STATUS_LABELS = {
    pending: 'Na fila',
    in_review: 'Em análise',
    completed: 'Concluída',
    rejected: 'Não analisada',
};

export const FUNNEL_LABELS = {
    discovery: 'Descoberta',
    consideration: 'Consideração',
    conversation: 'Conversa',
    conversion: 'Compra',
};

export const GOAL_LABELS = {
    grow: 'Atrair',
    connect: 'Aproximar',
    convert: 'Vender',
};

export const FORMAT_LABELS = {
    reels: 'Reels',
    carousel: 'Carrossel',
    photo: 'Foto',
    stories: 'Stories',
};

export const MONETIZATION_LEVELS = [
    { key: 'top', label: 'Atrair', hint: 'Quem ainda não te conhece' },
    { key: 'middle', label: 'Engajar', hint: 'Quem já te acompanha' },
    { key: 'bottom', label: 'Vender', hint: 'Quem está pronto para comprar' },
];

export const CONFIDENCE_LABELS = {
    low: 'Confiança baixa',
    medium: 'Confiança média',
    high: 'Confiança alta',
};

export function scoreTone(score) {
    if (score >= 75) {
        return 'good';
    }

    if (score >= 55) {
        return 'fair';
    }

    return 'weak';
}

export function formatNumber(value, options) {
    if (value === null || value === undefined) {
        return null;
    }

    return Number(value).toLocaleString('pt-BR', options);
}

export function formatDate(value) {
    if (!value) {
        return '';
    }

    const [year, month, day] = String(value).slice(0, 10).split('-');

    return `${day}/${month}/${year}`;
}
